import { render } from "./About.vue?vue&type=template&id=ec29662a"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=ec29662a&lang=scss"
script.render = render

export default script